"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c;
    return ({
        container: __assign(__assign({}, material_kit_pro_react_1.container), (_a = { display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'center', maxWidth: '295px' }, _a[theme.breakpoints.up('sm')] = {
            maxWidth: '480px'
        }, _a)),
        screen: {
            minHeight: '100%',
            paddingBottom: function (props) { return !props.isResetPasswordV2 ? theme.spacing(4) : theme.spacing(0); }
        },
        card: {
            marginTop: theme.spacing(4),
            background: theme.palette.background.default,
            borderRadius: '10px'
        },
        cardContent: {
            padding: function (props) { return !props.isResetPasswordV2 ? 0 : '0 !important'; }
        },
        cardContentInner: (_b = {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            _b[theme.breakpoints.down('xs')] = {
                paddingBottom: theme.spacing(2)
            },
            _b[theme.breakpoints.up('sm')] = {
                paddingBottom: function (props) { return !props.isResetPasswordV2 ? theme.spacing(2) : theme.spacing(0); }
            },
            _b),
        titleText: (_c = {},
            _c[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(2),
                marginBottom: 16
            },
            _c[theme.breakpoints.up('sm')] = {
                marginTop: theme.spacing(2),
                marginBottom: 32
            },
            _c)
    });
});
exports.default = styles;
//# sourceMappingURL=styles.js.map